module.exports = __webpack_public_path__ + "c8ef4506e2dc5115ce7b08330f1d8c7b.jpg";